
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { DROPDOWN_AREA_PROMPT } from '../../utils/constants';

@Component({})
export default class ImageUploader2 extends Vue {
  @Prop() dropAreaHeight!: string;

  readonly dropdownAreaPrompt = DROPDOWN_AREA_PROMPT;
  isOverFile: boolean = false;

  openFileExplorer(): void {
    (this.$refs.fileInputRef as HTMLInputElement).click();
  }
  onFileDropped(e: DragEvent): void {
    if (e.dataTransfer?.files?.length && e.dataTransfer.files[0].type.startsWith('image')) {
      this.onUpload(e.dataTransfer.files[0]);
    }
  }
  resetInputState(): void {
    (this.$refs.fileInputRef as HTMLInputElement).value = '';
  }

  onUploadByBrowsing(e: Event): void {
    const el = e.target as HTMLInputElement;
    if (el?.files?.length) {
      this.onUpload(el.files[0]);
    }
  }

  private onUpload(file: any): void {
    this.applyImage(file);
  }

  onFileDraggedOver(e: DragEvent): void {
    this.isOverFile = true;
  }

  onFileDraggedLeft(): void {
    this.isOverFile = false;
  }

  @Emit()
  applyImage(imageFile: File): File {
    return imageFile;
  }
}
